import { z } from 'zod';
import { optionalString, requiredString } from '../utils/basicSchemas/document.z.schema';
import { mongoId, mongoIdSchema } from '../utils/basicSchemas/_id.z.schema';
import { ZSchema } from '../utils/zodSchema';
import { subcatInputConfigSchema } from '.';

const categorySchemaFull = z.object({
    title: requiredString("Category title"),
    description: z.string().optional().nullable().default(null),
    subCategories: z.array(mongoIdSchema).optional(),
    creator: mongoIdSchema.optional(),
    values: z.record(z.array(subcatInputConfigSchema)),
});

const categoryMongooseSchema = z.object({
    title: requiredString("Category title"),
    description: z.string().optional().nullable().default(null),
    subCategories: z.array(mongoIdSchema).optional(),
    creator: mongoIdSchema.optional(),
});

const categoryClientSchema = z.object({
    name: requiredString("Category title"),
    createdBy: mongoIdSchema.optional(),
    createdOn: optionalString("Created On"),
    description: z.string().optional().nullable().default(null),

    subcategories: z.array(mongoIdSchema).optional(),
    postsWithin: z.number()
});

type CategoryStruct = z.infer<typeof categoryClientSchema>;
type MongooseCategoryStruct = z.infer<typeof categoryMongooseSchema>;

export { CategoryStruct, MongooseCategoryStruct };

const categorySchema = z.object({
    title: requiredString("Category title"),
    description: z.string().optional().nullable().default(null),
    hidden: z.boolean()
});

const categoryUpdateSchema = z.object({
    updates: z.object({
        title: requiredString("Category title"),
        description: z.string().optional().nullable().default(null),
    })
});

const categoryIdSchema = z.object({
    id: mongoId("Category id"),
});

// Export schemas 
export { categorySchemaFull };

// Define and export validators 
const categoryIdValidator = new ZSchema({ paramSchema: categoryIdSchema });
const categoryValidator = new ZSchema({ bodySchema: categorySchema });
const categoryUpdateValidator = new ZSchema({
    paramSchema: categoryIdSchema, bodySchema: categoryUpdateSchema
});
export { categoryIdValidator, categoryUpdateValidator, categoryValidator };


// Infer types and Export 
type CategorySchemaType = z.infer<typeof categorySchemaFull>;
export { CategorySchemaType }

